
import {connect} from 'react-redux';
import Loading from '../components/Loading';
import {login} from '../reducers';

/**
 * Root container that hides all children until the user is properly logged in
 * ie he signed in with google and created / fetched his user
 * 
 */

const mapStateToProps = state => ({
  loading:!login(state)
})

export default connect(mapStateToProps)(Loading);



// WEBPACK FOOTER //
// ./src/containers/WaitForLogin.js